import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';
import {
	buildMetricCompositeId,
	buildUnverifiedSkeleton,
	getMetricVerificationObjectType,
	type VerificationInfo,
} from 'webapp/utils/verification';

import VerificationToggleComponent from 'webapp/components/verification/toggle';

import type { Metric } from 'webapp/models-custom';

interface Args {
	metric: Metric;
	isDisabled?: boolean;
}

export default class VerificationToggleMetricComponent extends Component<Args> {
	@service('model-manager/metrics') declare mmMetricsService: Service.ModelManager.Metrics;

	get canShow(): boolean {
		const metric = this.args.metric;
		return !!this.verification && (metric.canEdit || metric.canEditDefinition);
	}

	get verification(): VerificationInfo | undefined {
		const metric = this.args.metric;
		if (metric.verificationInfo) {
			return metric.verificationInfo;
		}
		if (!metric.key || !metric.spaceAccessId) {
			return undefined;
		}
		return buildUnverifiedSkeleton(
			buildMetricCompositeId(metric.key, metric.spaceAccessId),
			getMetricVerificationObjectType(metric.objectType),
		);
	}

	@action
	toggle(): void {
		void this.mmMetricsService.toggleVerification(this.args.metric);
	}

	<template>
		{{#if this.canShow}}
			<VerificationToggleComponent
				@verification={{this.verification}}
				@entityLabel="metric"
				@onToggle={{this.toggle}}
				@isDisabled={{@isDisabled}}
			/>
		{{/if}}
	</template>
}
